import { mapActions, mapGetters, mapMutations } from 'vuex'
import general from '../general/index.vue'

export default {
    name: 'setting-llm-parameters-dialog-view',
    data () {
        return {
            dialog: true
        }
    },
    components: {
        general
    },
    watch: {
        openDialogView () {
            this.dialog = this.openDialogView
        }
    },
    computed: {
        ...mapGetters({
            currentItem: 'settingLlmParameters/currentItem',
            openDialogView: 'settingLlmParameters/openDialogView',
            editId: 'settingLlmParameters/editId'
        })
    },
    created () {
        if (this.editId) {
            this.fetchItem()
        }
    },
    methods: {
        ...mapActions({
            fetchItem: 'settingLlmParameters/GET_LIST_ITEM'
        }),
        ...mapMutations({
            changeDialogView: 'settingLlmParameters/CHANGE_DIALOG_VIEW',
            changeEditId: 'settingLlmParameters/CHANGE_EDIT_ID',
            setContent: 'settingLlmParameters/SET_ITEM'
        }),
        changeCloseDialog () {
            this.dialog = false

            this.changeDialogView(false)
            this.changeEditId('')
            this.setContent(null)
        }
    },
    destroyed () {
        this.setContent(null)
    }
}
